import React from 'react';
import { useMutation } from '@apollo/client';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { DELETE_USER_CALENDAR } from '../../../graphql';

type Props = {
  items: Array<{ id: string; name: string }>;
  userId: string;
};

export default function CalendarsEditor({ items, userId }: Props) {
  const [deleteUserCalendar] = useMutation(DELETE_USER_CALENDAR);
  const onDelete = (id: string) => {
    deleteUserCalendar({ variables: { calendarId: id, userId } }).catch((e) => console.log(e));
  };

  return (
    <>
      {items.length > 0 ? (
        <Row>
          {items.map((item) => (
            <Col key={item.id} md="auto" className="mb-4">
              <Card>
                <Card.Header>{item.id}</Card.Header>
                <Card.Body className="d-flex flex-column">
                  <Card.Text>{item.name}</Card.Text>
                  <Button variant="danger" onClick={() => onDelete(item.id)}>
                    Remove
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      ) : (
        <i>No calendars</i>
      )}
    </>
  );
}
